import { createClient } from '@supabase/supabase-js';

// Supabase 설정
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://your-project.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'your-anon-key';

// Supabase 클라이언트 생성
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});

// 타입 정의
export interface Database {
  public: {
    Tables: {
      users: {
        Row: {
          id: string;
          email: string;
          display_name: string;
          photo_url: string;
          user_type: 'advertiser' | 'reviewer';
          created_at: string;
          updated_at: string;
          sns_connections: {
            google?: {
              url: string;
              username: string;
              connected: boolean;
              created_at: number;
              updated_at: number;
            };
            instagram?: {
              url: string;
              username: string;
              connected: boolean;
              created_at: number;
              updated_at: number;
            };
            youtube?: {
              url: string;
              username: string;
              connected: boolean;
              created_at: number;
              updated_at: number;
            };
            naver?: {
              url: string;
              username: string;
              connected: boolean;
              created_at: number;
              updated_at: number;
            };
            blog?: {
              url: string;
              username: string;
              connected: boolean;
              created_at: number;
              updated_at: number;
            };
          };
        };
        Insert: {
          id: string;
          email: string;
          display_name: string;
          photo_url?: string;
          user_type: 'advertiser' | 'reviewer';
          created_at?: string;
          updated_at?: string;
          sns_connections?: any;
        };
        Update: {
          id?: string;
          email?: string;
          display_name?: string;
          photo_url?: string;
          user_type?: 'advertiser' | 'reviewer';
          created_at?: string;
          updated_at?: string;
          sns_connections?: any;
        };
      };
      campaigns: {
        Row: {
          id: string;
          title: string;
          description: string;
          image_url: string;
          category: string;
          start_date: string;
          end_date: string;
          status: 'active' | 'completed' | 'pending';
          created_by: string;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          title: string;
          description: string;
          image_url: string;
          category: string;
          start_date: string;
          end_date: string;
          status: 'active' | 'completed' | 'pending';
          created_by: string;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          title?: string;
          description?: string;
          image_url?: string;
          category?: string;
          start_date?: string;
          end_date?: string;
          status?: 'active' | 'completed' | 'pending';
          created_by?: string;
          created_at?: string;
          updated_at?: string;
        };
      };
      reviews: {
        Row: {
          id: string;
          campaign_id: string;
          user_id: string;
          content: string;
          rating: number;
          images: string[];
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          campaign_id: string;
          user_id: string;
          content: string;
          rating: number;
          images?: string[];
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          campaign_id?: string;
          user_id?: string;
          content?: string;
          rating?: number;
          images?: string[];
          created_at?: string;
          updated_at?: string;
        };
      };
    };
    Views: {
      [_ in never]: never;
    };
    Functions: {
      [_ in never]: never;
    };
    Enums: {
      [_ in never]: never;
    };
  };
}

export type Tables<T extends keyof Database['public']['Tables']> = Database['public']['Tables'][T]['Row'];
export type Enums<T extends keyof Database['public']['Enums']> = Database['public']['Enums'][T];
